@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
}
